import { FormControl, Validators } from '@angular/forms';

import { customFormGroup } from '../utilities';
import { Breadcrumb } from './breadcrumb.interface';

export const sampleForm = () => {
  return customFormGroup(
    {
      attrToSave: new FormControl<unknown>(5, [Validators.required]),
      server: new FormControl<unknown>('', [Validators.required]),
      attrFilter: new FormControl<unknown>(
        { id: 9, name: 'Robert', lastName: 'Taylor' },
        [Validators.required]
      ),
      freeText: new FormControl<unknown>('Test'),
      query: new FormControl<unknown>(''),
      chips: new FormControl<unknown>([]),
      chipsAutocomplete: new FormControl<unknown>([]),
      queryRequired: new FormControl<unknown>('', [Validators.required]),
      startDate: new FormControl<string | null>(null),
      endDate: new FormControl<string | null>(null),
    },
    {
      errorMessages: [
        {
          fieldKey: 'queryRequired',
          errorName: 'required',
          message: 'This is a custom error message',
        },
      ],
    }
  );
};

export interface SampleInterface {
  hello: string;
}

export const sampleBreadcrumbs: Breadcrumb[] = [
  { label: 'Home', selected: false },
  { label: 'Test', selected: false },
  { label: 'Sample', selected: true },
];

export const MOCK_JSON_DATA = [
  {
    updated_at: '2022-08-15T11:26:04.174583Z',
    id: 'ac83a294a613688415ce82bcfc2511f629785cdfd0ea95bc288fefbaaafe31b7',
    event_time: '2022-08-15T11:25:25Z',
    collection_info: {
      sub_source: '22222',
      ingest_time: '2022-08-15T11:26:02.219341Z',
      raw_source_file:
        'gs://q6-optuna-data/89.163.242.96-Administrator/clipboard-text/2022-08-15_11-25-51-clipboard.txt',
      source: 'drneuron',
      collection_time: '2022-08-15T11:25:51Z',
      type: 'TA_DIRECT',
      source_name: 'SunnyEyebrow-1',
    },
    _concurrencyControl: {
      _seq_no: 1946007,
      _primary_term: 1,
    },
  },
  {
    updated_at: '2022-08-15T11:26:04.171105Z',
    id: '9ed4061c10ad67a15b434e37eecb8e287123125a94b9af66c2e2c98443dc26ea',
    event_time: '2022-08-15T11:25:53Z',
    collection_info: {
      sub_source: '88888',
      ingest_time: '2022-08-15T11:26:02.289881Z',
      raw_source_file:
        'gs://q6-optuna-data/89.163.242.96-Administrator/keyscan/2022-08-15_11-25-53-keyscan.txt',
      source: 'drneuron',
      collection_time: '2022-08-15T11:25:53Z',
      type: 'TA_DIRECT',
      source_name: 'SunnyEyebrow-1',
    },
    _concurrencyControl: {
      _seq_no: 1950873,
      _primary_term: 1,
    },
  },
  {
    updated_at: '2022-08-15T11:27:46.514645Z',
    id: 'fa36c744e1cb7c6b7bbfe3e1540b4efe288ffe58f16f12a1f238ba8a5da167c0',
    event_time: '2022-08-15T11:26:50Z',
    collection_info: {
      sub_source: '999999',
      ingest_time: '2022-08-15T11:27:44.503309Z',
      raw_source_file:
        'gs://q6-optuna-data/89.163.242.96-Administrator/clipboard-text/2022-08-15_11-27-11-clipboard.txt',
      source: 'drneuron',
      collection_time: '2022-08-15T11:27:11Z',
      type: 'TA_DIRECT',
      source_name: 'SunnyEyebrow-1',
    },
    _concurrencyControl: {
      _seq_no: 1947335,
      _primary_term: 1,
    },
  },
];
